import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { environment } from '../../environments/environment';

export type RequestMethod = 'GET' | 'PUT' | 'POST' | 'DELETE';
export type RequestParams = HttpParams | { [param: string]: string | string[] | undefined };

/**
 * Base class for services that call the API Gateway
 */
export abstract class ApiGatewayService {
  protected constructor(protected http: HttpClient, private readonly basePath: string) {
    if (!this.basePath.endsWith('/')) {
      this.basePath += '/';
    }
  }

  private getUrl(path: string | string[]) {
    if (Array.isArray(path)) {
      path = path.join('/');
    }
    return new URL(this.basePath + path, environment.apigwURL);
  }

  private request<T>(method: RequestMethod, path: string | string[], params: RequestParams): Promise<T> {
    const url = this.getUrl(path);

    return this.http.request<T>(method, url.href, {
      // remove undefined parameters
      params: Object.fromEntries(Object.entries(params).filter(([key, value]) => value !== undefined)),
      responseType: 'json'
    }).toPromise();
  }

  protected requestWithResponse<T>(method: RequestMethod, path: string | string[], params: RequestParams): Promise<HttpResponse<T>> {
    const url = this.getUrl(path);

    return this.http.request<T>(method, url.href, {
      // remove undefined parameters
      params: Object.fromEntries(Object.entries(params).filter(([key, value]) => value !== undefined)),
      observe: 'response',
      responseType: 'json'
    }).toPromise();
  }

  protected getWithResponse<T>(path: string | string[], params: RequestParams = {}): Promise<HttpResponse<T>> {
    return this.requestWithResponse('GET', path, params);
  }

  protected get<T>(path: string | string[], params: RequestParams = {}): Promise<T> {
    return this.request('GET', path, params);
  }
}
